<div class="users__wrapper">
    <ng-container *ngIf="summary$ | async as summary">
      <div class="w-100 overflow-hidden">
        <div class="widget__text--small text-truncate mb-md-1 mb-lg-2">Users online</div>
        <div class="widget__text--large text-truncate">{{ summary.donorsOnline }} of {{ summary.registered }}</div>
      </div>
    </ng-container>
    <app-icon-users-online></app-icon-users-online>
  </div>